module.exports = __webpack_public_path__ + "mm.svg?0c6003070a22ac6b8528b7d033b28ae4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mm.svg
// module id = 879
// module chunks = 27